import {MarkTemplateDto, MarkCriteria} from '../../dto/MarkTemplateDto';

export const getPositionLabel = (positions: string[]) => positions.map((el) => el.replace(/_/g, ' '));

export const optimizePositionsList = (positions: string[], projectPositions: string[]) =>
    positions.length === projectPositions.length ? ['ALL'] : positions;

export const mapMarkTemplates = (markTemplates: MarkTemplateDto[]) => {
    const allCriterias = markTemplates.map(({markCriterias}) => markCriterias).flat();
    const criteriasIds = Array.from(new Set(allCriterias.map((el) => el.id)));
    const markCriterias = criteriasIds
        .map((id) => allCriterias.find((el) => el.id === id) as MarkCriteria)
        .sort((a, b) => a.coefficientLimit - b.coefficientLimit);

    const positionsWithIds = criteriasIds.map((markCriteriaId) => {
        const positions = markTemplates
            .map(({markCriterias, position, id}) => {
                if (markCriterias.some((el) => el.id === markCriteriaId)) {
                    return {position, id};
                }
                return null;
            })
            .filter((el) => el) as {position: string; id: number}[];

        return {markCriteriaId, positions};
    });

    return {markCriterias, positionsWithIds};
};
